import { styled } from "styled-components";

export const StyleWrapper = styled.div<{ $center?: boolean }>`
  width: 800px;
  height: auto;
  display: flex;      
  box-sizing: border-box;
  margin-top: 100px;  
  flex-direction: column;
  justify-content: ${({ $center }) => $center ? "center" : "flex-start"};
  align-items: ${({ $center }) => $center ? "center" : "flex-start"};
  @media (max-width: 768px) {
    width: 100%;
    padding: 15px;
  }
`;